import React, { useEffect, useState } from 'react';
import AdminLayout from '../../components/admin/AdminLayout';
import styles from './AdminOrders.module.css';
import { apiService } from '../../services/api';

const AdminOrders = () => {
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    apiService.getOrders()
      .then(data => setOrders(data.orders || []))
      .catch(() => setOrders([]));
  }, []);

  return (
    <AdminLayout>
      <div className={styles.ordersManagement}>
        <div className={styles.header}>
          <h1>Órdenes</h1>
        </div>
        <div className={styles.ordersTable}>
          <div className={styles.tableHeader}>
            <div>Cliente</div>
            <div>Correo</div>
            <div>Teléfono</div>
            <div>Dirección</div>
            <div>Total</div>
            <div>Estado</div>
            <div>Fecha</div>
          </div>
          {orders.map(order => (
            <div key={order.id} className={styles.tableRow}>
              <div>{order.user_name}</div>
              <div>{order.user_email}</div>
              <div>{order.user_phone}</div>
              <div>{order.user_address}</div>
              <div>${order.total?.toFixed(2)}</div>
              <div>
                <span className={styles[order.status]}>
                  {order.status.charAt(0).toUpperCase() + order.status.slice(1)}
                </span>
              </div>
              <div>{new Date(order.created_at).toLocaleString()}</div>
            </div>
          ))}
        </div>
      </div>
    </AdminLayout>
  );
};

export default AdminOrders;